import dayjs from 'dayjs'
import { complainStatus } from '@/constants/customerComplain'

export default {
  getManagerList: (state) => state.managerList,
  getBackupManagerInfo: (state) => state.backupManagerInfo,
  getSelectedManagerInfo: (state) => state.selectedManagerInfo,
  getSelectedManagerAccount: (state) => state.selectedManagerInfo.account,
  getSelectedManagerDepartment: (state) => state.selectedManagerInfo.department,
  getSelectedManagerEmail: (state) => state.selectedManagerInfo.email,
  getSelectedManagerName: (state) => state.selectedManagerInfo.name,
  getSelectedManagerNote: (state) => state.selectedManagerInfo.note,
  getSelectedManagerPhone: (state) => state.selectedManagerInfo.phone,
  getSelectedManagerPositionId: (state) => state.selectedManagerInfo.positionId,
  getSelectedManagerServiceNumber: (state) =>
    state.selectedManagerInfo.serviceNumber,
  getSelectedManagerServicePhone: (state) =>
    state.selectedManagerInfo.servicePhone,
  /* 取得登入使用者的團隊角色權限 */
  getTeamRoles: (state) => state.teamRoles,
  /* 整理客訴事件表格的資料 */
  getComplainList: (state) => {
    return state.complainList.map((item) => {
      const driver = state.driverList.find(({ id }) => id === item.driver_id)
      return {
        serviceName: `${driver ? driver.call_number : '無司機隊編'}-${
          driver && item.add_service ? driver.name : '無立案人姓名'
        }`,
        happenTime: dayjs(item.event_time).format('YYYY-MM-DD HH:mm:ss'),
        registerTime: dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
        eventTitle: item.event_content,
        desc: item.processing_description,
        status: complainStatus[item.status].label,
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/managerStore/getters.js